<template>
    <div class="appHeader bg-primary text-light" v-if="this.$route.name == 'Home' || this.$route.name == 'Welcome' || this.$route.name == 'Register' || this.$route.name == 'Login'">
        <div class="left">
            <a href="javascript:void(0)" class="headerButton" data-bs-toggle="modal" data-bs-target="#sidebarPanel">
                <ion-icon name="menu-outline"></ion-icon>
            </a>
        </div>
        <div class="pageTitle">
            <img src="assets/img/wisdom-guide.png" alt="logo" class="logo">
        </div>
        <div class="right">
            <a href="/#/notifications" class="headerButton" v-if="this.$route.name != 'Welcome'">
                <ion-icon class="icon" name="notifications-outline"></ion-icon>
                <span class="badge badge-danger" v-if="unreadNotificationCount > 0">{{ unreadNotificationCount }}</span>
            </a>
            <router-link :to="'/user-login'" v-if="this.$route.name == 'Welcome'">
                <a href="javascript:void(0)" class="headerButton">
                    Login<ion-icon class="icon" name="log-in-outline"></ion-icon>
                </a>
            </router-link>
        </div>
    </div>
    <!-- App Header -->
    <div class="appHeader" v-else>
        <div class="left">
            <a href="javascript:void(0)" class="headerButton goBack" @click="goBack()">
                <ion-icon name="chevron-back-outline"></ion-icon>
            </a>
        </div>
        <div class="pageTitle">
            {{ page_header ? page_header : this.$route.name }}
        </div>
        <div class="right">
            <button v-if="minutes || seconds" type="button" class="btn btn-outline-danger me-1 mb-1">{{ minutes }}:{{ seconds }}</button>
            <!-- Per-page header action buttons (e.g. calendar, filter) -->
            <a
              v-for="action in header_actions"
              :key="action.key"
              href="javascript:void(0)"
              class="headerButton header-action-btn"
              :title="action.label"
              @click="action.onClick ? action.onClick() : $emit('header-action', action.key)"
            >
              <span class="header-action-wrap">
                <ion-icon :name="action.icon"></ion-icon>
                <span v-if="action.badge" class="header-action-badge"></span>
              </span>
            </a>
        </div>

    </div>
    <!-- * App Header -->
    
    <!-- App Header -->
    <div class="appHeader no-border transparent position-absolute" v-if="this.$route.name == 'Login'">
        <div class="left">
            <a href="/" class="headerButton goBack">
                <ion-icon name="chevron-back-outline"></ion-icon>
            </a>
        </div>
        <div class="pageTitle"></div>
        <div class="right">
        </div>
    </div>
    <!-- * App Header -->
</template>

<script>
import UserService from "../../services/user.service";

export default {
    props: {
        page_header: String,
        minutes: String,
        seconds: String,
        header_actions: { type: Array, default: () => [] },
    },
    emits: ['header-action'],
    computed: {
        currentUser() {
            return this.$store.state.auth.user;
        },
        isHomeRoute() {
            return this.$route.name === 'Home';
        },
        unreadNotificationCount() {
            if (this.isHomeRoute) {
                return this.$store.state.app.unreadNotificationCount;
            }
            return this.localUnreadNotificationCount;
        },
    },
    data() {
        return {
            localUnreadNotificationCount: 0,
        };
    },
    methods: {
        goBackAnimation() {
            // Go Back Animation
            // pageBody.classList.add("animationGoBack")
            setTimeout(() => {
                this.$router.go(-1);
            }, 300);
        },
        goBack() {
            // Check if we're on a meeting detail page or related meeting pages
            const currentRoute = this.$route.path;
            const currentQuery = this.$route.query.tab;
            
            if (currentRoute.startsWith('/meeting/')) {
                // If on meeting detail page, go back to meetings page (Home tab)
                this.$router.push('/meetings');
            } else if (currentRoute === '/meetings') {
                // If on meetings page, check if we have a tab query param
                // If we're on Upcoming, Old, or Assignments tab, go back to Home tab
                if (currentQuery === 'upcoming' || currentQuery === 'old' || currentQuery === 'assignments') {
                    // Navigate to Home tab by going to /meetings without query params
                    this.$router.push('/meetings');
                } else {
                    // Already on Home tab or no tab specified, use browser history
                    this.$router.go(-1);
                }
            } else {
                // Otherwise, use browser history
                this.$router.go(-1);
            }
        },
        fetchNotificationCount() {
            if (this.isHomeRoute) {
                return;
            }
            UserService.authGetRequest('notifications/user').then(
                (response) => {
                    if (response.data.status === 'success') {
                        const notifications = response.data.data.notifications;
                        this.localUnreadNotificationCount = notifications.filter(notification => !notification.read_at).length;
                    }
                },
                (error) => {
                    console.error('Error fetching notifications:', error);
                    this.localUnreadNotificationCount = 0;
                }
            );
        }
    },
    mounted() {
        // Go Back Button
        var goBackButton = document.querySelectorAll(".goBack");
        goBackButton.forEach(function(el) {
            el.addEventListener("click", function() {
                // if (Finapp.Animation.goBack) {
                //     goBackAnimation();
                // }
                // else {
                //     this.$router.go(-1);
                // }

            })
        })

        if (this.currentUser) {
            this.fetchNotificationCount();
        }

    },

    watch: {
        // Watch for route changes and update notification count
        '$route'() {
            if (this.currentUser) {
                this.fetchNotificationCount();
            }
        }
    },
};
</script>
<style scoped>
.header-action-wrap {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}
.header-action-badge {
  position: absolute;
  top: -3px;
  right: -4px;
  width: 8px;
  height: 8px;
  background: #ff3b30;
  border-radius: 50%;
  border: 1.5px solid #fff;
}
</style>